import React from "react";

import styles from "./NoReviewsStile.module.scss";

export const NoReviews: React.FC = () => (
  <div className={styles.container}>
    <h1><span className={styles.colored}>0</span>&nbsp;Reviews</h1>
    <h3>Unfortunately, no reviews yet...</h3>
  </div>
);